import { ref } from 'vue'

// Reaktiv netværksstatus, delt på tværs af appen (samme module-state-mønster som
// useUnits / useTheme). navigator.onLine giver startværdien; online/offline-events
// holder den opdateret. Det er et groft signal (interface up ≠ internet), men sammen
// med service-workerens cache-fallback er det rigeligt til at styre UI'et.
const online = ref(navigator.onLine)

window.addEventListener('online', () => (online.value = true))
window.addEventListener('offline', () => (online.value = false))

export function useOnline() {
  return { online }
}

export { online }
